import { render, staticRenderFns } from "./ItemDetailFailure.vue?vue&type=template&id=f544ecf0&"
import script from "./ItemDetailFailure.vue?vue&type=script&lang=ts&"
export * from "./ItemDetailFailure.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports